const API = "https://jm.komerzy.com/backend/?url=usuariosapi";

// Función para obtener token desde localStorage
const getToken = () => localStorage.getItem("token");

export const getUsuarios = async () => {
  const token = getToken();

  const res = await fetch(`${API}&action=listar`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const json = await res.json();
  return json.data;
};

export const saveUsuario = async (data) => {
  const token = getToken();

  const res = await fetch(`${API}&action=guardar`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  return res.json();
};

export const deleteUsuario = async (idusuario) => {
  const token = getToken();

  const res = await fetch(`${API}&action=eliminar`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ idusuario }),
  });

  return res.json();
};
